import type { Translation } from "@/i18n/locales/types";

export const nav: Translation["nav"] = {
  ariaLabel: "Main",
  sectionMe: "Me",
  sectionSettings: "Settings",
  home: "Home",
  certificates: "Certificates",
  policies: "Policies",
  people: "People",
  activity: "Activity",
  myCertificates: "My certificates",
  myActivity: "My activity",
  organization: "Organization",
  openMenu: "Open menu",
  organizationSwitcher: "Switch organization",
  userMenu: "User menu",
  language: "Language",
  platform: "Platform",
  platformAdmin: "Platform admin",
  logout: "Log out",
};
